import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { StockCard } from '../c/ChartCard';
import { T } from '../traks';

import SearchField from '../c/SearchField';
import { StockExploreCard } from './Explore.js';

const G = (props) => props.children;

var ExploreSTO = (props) => {
	var sections = [];

	sections.push(
		<Row key="vndjcgfBIURGMj0i" className="align-items-center">
			<Col xs="12" className="pb-3">
				<h3 className="pt-5"><T>Swedish collections</T></h3>
			</Col>
			<StockExploreCard ticker="OMXS30" exchange="IDX-SEK" card_img="/gfx/omxs30-350x136-0.svg" name="OMXS30" href="/portfolio/9218"/>
			<Col xs="12" className="pb-3">
				<h3><T>Selected Swedish stocks</T></h3>
			</Col>
			<StockExploreCard ticker="HM-B" exchange="STO" card_img="/gfx/hennesmauritz-350x136-0.svg" name="Hennes & Mauritz" href="/ticker/STO/HM-B"/>
			<StockExploreCard ticker="SAAB-B" exchange="STO" card_img="/gfx/saab-350x136-0.svg" name="SAAB Solutions" href="/ticker/STO/SAAB-B"/>
			<StockExploreCard ticker="GOMX" exchange="STO" card_img="/gfx/gomspace-350x136-0.svg" name="Gomspace" href="/ticker/STO/GOMX"/>
			<StockExploreCard ticker="VOLV-B" exchange="STO" card_img="/gfx/volvo-350x136-0.svg" name="Volvo" href="/ticker/STO/VOLV-B"/>
			<StockExploreCard ticker="NCC-B" exchange="STO" card_img="/gfx/ncc-350x136-0.svg" name="NCC" href="/ticker/STO/NCC-B"/>
			<StockExploreCard ticker="ERIC-B" exchange="STO" card_img="/gfx/ericsson-350x136-0.svg" name="Ericsson" href="/ticker/STO/ERIC-B"/>
			<StockExploreCard ticker="SEB-C" exchange="STO" card_img="/gfx/seb-350x136-0.svg" name="SEB" href="/ticker/STO/SEB-C"/>
			<StockExploreCard ticker="SKA-B" exchange="STO" card_img="/gfx/skanska-350x136-0.svg" name="Skanska" href="/ticker/STO/SKA-B"/>
			<StockExploreCard ticker="SWMA" exchange="STO" card_img="/gfx/swedishmatch-350x136-0.svg" name="Swedish Match" href="/ticker/STO/SWMA"/>
		</Row>

	);

	for (const section of props.home.Sections) {
		var items = [];

		const mk_stock_item = (asset) => {
			const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
			return (
				<Col key={key} md="3" className="pb-4">
					<StockCard
						exchange={asset.Exchange}
						ticker={asset.Ticker}
						range="3m"
					/>
				</Col>
			);
		};

		switch (section.Type) {
			case "STOCKS":
				items = section.Content.map(mk_stock_item);
				break;
			default:
				continue;
		}
		sections.push(
				<span key="SPANNING_ALL">
				<Row key={section.Type}>
					<Col xs="12" className="pb-3">
						<h3><T>Random Swedish stocks</T></h3>
					</Col>
				</Row>
				<Row>
					{items}
				</Row>
				</span>
		);
	}

	const placeholder = <T>Search Swedish assets</T>;

	return (
		<G>
			<div className="d-flex flex-column text-center ad_explore_large_img_sto justify-content-center">
				<div className="pt-5 text-white ad_explore_txt_header"><T>Sweden</T></div>
				<div className="text-white pb-3 ad_explore_txt_subheader px-2"><T>Explore assets exclusively from Sweden</T></div>
				<SearchField placeholder={placeholder} market="SE_STOCK" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</G>
	);
}

ExploreSTO = Apify("/z/explore?market=SE_STOCK")
	.with_response_prop("home")
	.wrap(ExploreSTO, ApifyFullScreenLoadingComponent);

export default ExploreSTO;



// WEBPACK FOOTER //
// ./src/p/ExploreSTO.js